var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0fb8bc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5146 11881)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,8v6a6.007,6.007,0,0,1-6,6H8a1,1,0,0,0,0,2h6a8.009,8.009,0,0,0,8-8V8a1,1,0,0,0-2,0Z",
    transform: "translate(-5148 -11883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,19a5.006,5.006,0,0,0,5-5V7a5.006,5.006,0,0,0-5-5H7A5.006,5.006,0,0,0,2,7v7a5.006,5.006,0,0,0,5,5ZM7.81,9.414l1.278,1.768,4.232-3.916a1,1,0,0,1,1.358,1.469l-5.06,4.682a1,1,0,0,1-1.489-.148L6.19,10.586A1,1,0,0,1,7.81,9.414Z",
    transform: "translate(-5148 -11883)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoApproved);
export default __webpack_public_path__ + "static/media/ICO_Approved.7e0c789fd653a94fa07c1e6e24755265.svg";
export { ForwardRef as ReactComponent };